import { Provider } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';

export const translateLoaderProviders: Provider[] = [
  { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: './assets/i18n/', suffix: '.json' } },
  { provide: TranslateLoader, useClass: TranslateHttpLoader },
];
